import React, { Component, useContext, useEffect } from "react";
import { useNavigate, useLocation, Link, NavLink } from "react-router";
import Sidebar from "./Sidebar";
import { AppContext } from "../../../Context/AppContext";
function Layout(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const appData = useContext(AppContext);
  // function handle_logout() {
  //   Logger.log(0, "Signout", "Signed Out");
  //   AuthManager.logoutUser();
  //   history.replace("/login");
  // }

  // function get_logged_User_name() {
  //   let userobj = null;
  //   if (AuthManager.isAuthenticated()) userobj = AuthManager.getAuthUser();
  //   if (
  //     userobj === null ||
  //     userobj === undefined ||
  //     userobj.profile === null ||
  //     userobj.profile === undefined
  //   )
  //     return "guest";
  //   return userobj.profile.first_name + " " + userobj.profile.last_name;
  // }
  useEffect(() => {
    if (!appData.pm.checkPermission("gmssettings_edit")) {
      navigate("/workspace/module/permission/denied");
    }
  }, []);
  return (
    <React.Fragment>
      <Sidebar />

      <main className="page-content h-100" data-page={location.pathname}>{props.children}</main>
    </React.Fragment>
  );
}

export default Layout;
